module.exports = __webpack_public_path__ + "img/14.8aa1ba8d.png";